import { render, staticRenderFns } from "./xuexiao-list.vue?vue&type=template&id=769cb315&scoped=true&"
import script from "./xuexiao-list.vue?vue&type=script&lang=js&"
export * from "./xuexiao-list.vue?vue&type=script&lang=js&"
import style0 from "./xuexiao-list.vue?vue&type=style&index=0&id=769cb315&lang=scss&scoped=true&"
import style1 from "./xuexiao-list.vue?vue&type=style&index=1&id=769cb315&lang=scss&scoped=true&"
import style2 from "./xuexiao-list.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769cb315",
  null
  
)

export default component.exports